import React, { useState, useEffect }  from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import { Link } from "react-router-dom";
import Navbar from "../navbar/Navbar";
import Footer from "../footer/footer";
import "./landing.css";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary
  }
}));

export default function FullWidthGrid() {
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const classes = useStyles();
  useEffect(() => {

    setTimeout(function(){ alert("Go paperless, avoid touching shared papers and books. Go digital and be safe from CORONA virus."); }, 2000);
  });

  return (
    <div className={classes.root}>
      <Navbar />
      <Grid
        container
        spacing={2}
        justify="center"
        style={{ padding: "10px" ,marginTop: "60px"}}
      >
        <Grid item xs={6} md={6}>
          {/* <Link to="/Calculator" id="lnk"> */}
          <Link to="/CoronaReport" id="lnk">
            <Paper
              style={{
                backgroundColor: "#26A65B",
                color: "white",
                fontSize: "23px"
              }}
              className={classes.paper}
            >
              {/* SGPA/CGPA Calculator */}
              Corona Report
            </Paper>
          </Link>
        </Grid>

        {/* <Grid item xs={12} md={3} id="yt-desk-grid">
          <Link to="/VideoClass" id="lnk">
            <Paper
              id="yt-desk"
              style={{
                textAlign: "center",

                color: "white",
                backgroundColor:'#e74c3c'
              }}
              className={classes.paper}
            >
              {" "}
              Video Class
            </Paper>
          </Link>
        </Grid> */}

        <Grid item xs={6} md={6}>
          <Link to="/Buyprojects" id="lnk">
            <Paper
              style={{
                backgroundColor: "rgba(7, 67, 136, 0.877)",
                textAlign: "center",
                fontSize: "23px"
              }}
              className={classes.paper}
            >
              <span id="sellbanner">Buy Project at low price</span>
              <p
                style={{
                  fontSize: "7px",
                  color: "white",
                  position: "absolute",
                  textAlign: "center",
                  marginTop: "-2px",
                  float: "right"
                }}
              >
                C.S.E 5th sem | 6th sem | 7th sem Available
              </p>
            </Paper>
          </Link>
        </Grid>

        <Grid item xs={6} sm={3}>
          <Link to="/Notes" id="lnk">
            <Paper id="notes" className={classes.paper}>
              Notes
            </Paper>
          </Link>
        </Grid>
        <Grid item xs={6} sm={3}>
          <Link to="/QuestionBank" id="lnk">
            <Paper id="qb" className={classes.paper}>
              Question Banks
            </Paper>
          </Link>
        </Grid>

        {/* <Grid item xs={12} md={3} id="yt-mob">
          <Link to="/VideoClass" id="lnk">
            <Paper
              style={{
                backgroundColor: "rgba(7, 67, 136, 0.877)",
                textAlign: "center",
                fontSize: "13px",
                color: "white",
                height: "10px"
              }}
              className={classes.paper}
            >
              {" "}
              Video Class
            </Paper>
          </Link>
        </Grid> */}

        <Grid item xs={6} sm={3}>
          <Link to="/Projects" id="lnk">
            <Paper id="projects" className={classes.paper}>
              Projects
            </Paper>
          </Link>
        </Grid>
        <Grid item xs={6} sm={3}>
          <Link to="/VideoClass" id="lnk">
            <Paper id='Videonotes'  className={classes.paper}>
              Video class
            </Paper>
          </Link>
        </Grid>
      </Grid>

    
      <Footer />

      {/* <script src="../././../serviceWorker.js"></script> */}
    </div>
  );
}
